import { useEffect, useRef } from "react";
import { Animated } from "react-native";
import Svg, { Circle } from "react-native-svg";

// Completion score ring, ported from CPR_Course_Module1.html (#scoreRing:
// strokeDasharray 314, strokeDashoffset animates 314 -> 314*(1-pct/100) over 1s).
// The caller overlays the centered percent + fraction text.

const AnimatedCircle = Animated.createAnimatedComponent(Circle);
const C = 314;

type Props = { pct: number; color: string; size?: number };

export function ScoreRing({ pct, color, size = 118 }: Props) {
    const offset = useRef(new Animated.Value(C)).current;

    useEffect(() => {
        const anim = Animated.timing(offset, {
            toValue: C * (1 - pct / 100),
            duration: 1000,
            useNativeDriver: true
        });
        anim.start();
        return () => anim.stop();
    }, [offset, pct]);

    return (
        <Svg width={size} height={size} viewBox="0 0 118 118">
            <Circle cx={59} cy={59} r={50} fill="none" stroke="#E5EDF2" strokeWidth={9} />
            <AnimatedCircle
                cx={59}
                cy={59}
                r={50}
                fill="none"
                stroke={color}
                strokeWidth={9}
                strokeLinecap="round"
                strokeDasharray={C}
                strokeDashoffset={offset}
            />
        </Svg>
    );
}
